import { render, staticRenderFns } from "./M104.vue?vue&type=template&id=542755f2&scoped=true"
import script from "./M104.vue?vue&type=script&lang=js"
export * from "./M104.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=542755f2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542755f2",
  null
  
)

export default component.exports